<template>
    <!-- 出价 -->
    <Modal v-model="show.bidPrice" width="500" class="c-modal c-bid" @on-ok="regBidPrice">
        <p slot="header" class="modal-header">出价</p>
        <div class="modal-detail">
            <div class="modal-row">
                <Input
                    class="modal-row-input"
                    v-model.trim="bidPrice"
                    @on-keyup="(e)=>mixinRegNum(e, 5, 0, 99999999.99999)"
                    @on-change="(e)=>mixinRegNum(e, 5, 0, 99999999.99999)"
                    :maxlength="14"
                    icon="social-usd"
                    :placeholder="`必填，请输入不少于$${limit}的出价`"
                >
                    <Select v-model="bidType" slot="prepend" style="line-height: 36px;width:80px;">
                        <Option :value="2">CPA</Option>
                        <Option :value="3">CPC</Option>
                        <Option :value="1">CPM</Option>
                    </Select>
                </Input>
                <Icon v-if="!reg.bidPrice" type="android-cancel" class="icon-error"></Icon>
            </div>
        </div>
        <!-- 底部按钮 -->
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" size="large" @click="regBidPrice">保存</Button>
        </div>
    </Modal>
    <!-- 出价 -->
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
export default {
    name: 'cbid',
    mixins: [mixins],
    props: {
        //请求对象
        show: {
            type: Object,
        },
    },
    watch: {
        'show.bidPrice'(bool) {
            if (bool) {
                this.reg.bidPrice = true;
                this.bidPrice = '';
                this.bidType = 1;
            }
        },
    },
    data() {
        return {
            bidPrice: '',
            bidType: 1,
            reg: {
                bidPrice: true, //出价验证
            },
            bidTypeList: {
                1: 0.01,
                2: 0.03,
                3: 0.0006,
            },
        };
    },
    computed: {
        limit() {
            const userData = this.$store.state.userData;
            return userData.source == 'batmobi' ? 0 : this.bidTypeList[this.bidType];
        },
    },
    methods: {
        onCancel() {
            this.show.bidPrice = false;
            this.bidPrice = '';
        },
        /**
         * @desc: 验证是否填写了bidPrice
         */
        regBidPrice() {
            if (parseFloat(this.bidPrice) >= this.limit && parseFloat(this.bidPrice)) {
                this.reg.bidPrice = true;
                this.show.bidPrice = false;
                this.$emit('save', { type: this.bidType, value: this.bidPrice });
            } else {
                let msg = {
                    1: 'CPM出价不能小于0.01',
                    2: 'CPA出价不能小于0.03',
                    3: 'CPC出价不能小于0.0006',
                }[this.bidType];
                if (this.limit == 0) msg = '出价不能为0';
                this.reg.bidPrice = false;
                this.$Message.error({
                    content: msg,
                    duration: 1.5,
                });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';
.c-bid{
    .ivu-input-group-prepend,
    .ivu-input-group-append {
        background: none;
        font-size: 0.14rem;
        width: 0.7rem;
        & > span {
            position: relative;
            top: 1px;
        }
    }
    .ivu-select {
        position: relative;
        z-index: 1000;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cBid.vue